<template>
  <section class="main_wrap">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm login-container">
      <el-form-item label="邮箱" prop="email">
        <el-input type="email" v-model="ruleForm.email" auto-complete="off" placeholder="邮箱"></el-input>
      </el-form-item>
      <el-form-item label="原密码" prop="password">
        <el-input type="password" v-model="ruleForm.password" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="new_password">
        <el-input type="password" v-model="ruleForm.new_password" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input type="password" v-model="ruleForm.checkPass" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:8%;" @click="submitForm('ruleForm')" :loading="logining">提交</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
    import Vue from 'vue';
    
    import { patchResetPassword,getRequestToken } from '../../api/api';
    import { deleteToken, deleteEmail, goLoginOut } from "../../utils/authority.js";
    export default {
      created: function () {
        //token
        getRequestToken()
          .then((res) => {
            Vue.set(this.params, res.param, res.token);
          })
          .catch((error) => {
            alert("获取token失败，请刷新页面重试！");
            console.log(error)
          })
      },
      data() {
        var validatePass = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入密码'));
          } else {
            if (this.ruleForm.checkPass !== '') {
              this.$refs.ruleForm.validateField('checkPass');
            }
            callback();
          }
        };
        var validatePass2 = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请再次输入密码'));
          } else if (value !== this.ruleForm.new_password) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback();
          }
        };
          return {
            logining: false,
            ruleForm: {
              email: '',
              password: '',
              new_password: '',
              checkPass: ''
            },
            params: {},
            rules: {
              email: [
                { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }
              ],
              password: [
                { required: true, message: '请输入密码', trigger: 'blur' },
              ],
              new_password: [
                { required: true,validator: validatePass, trigger: 'blur' }
              ],
              checkPass: [
                { required: true,validator: validatePass2, trigger: 'blur' }
              ],
            },
          };
      },
      methods: {
        submitForm(formName){
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.params.email = this.ruleForm.email;
              this.params.password = this.ruleForm.password;
              this.params.new_password = this.ruleForm.new_password;
              this.logining = true;
              patchResetPassword(this.params).then(res => {
                  console.log(res);
                if(res.data.status === 0){
                  this.$message({
                    message: res.data.status_text,
                    type: 'success'
                  });
                  this.resetForm('ruleForm');
                  location.reload();
                }else {
                  this.$message({
                    message: res.data.status_text,
                    type: 'error'
                  });
                }
                this.logining = false;
              }).catch(() => {
                this.loading = false;
                this.$message({
                  message: '网络错误，请稍后重试！',
                  type: 'error'
                });
              });
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        }
      }
    }

</script>

<style lang="scss" scoped>
.main_wrap {
  padding: 30px 0 0 0;
  .el-form {
    .el-input {
      width: 35%;
      .el-input__inner {
        width: 35%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personalCenter/ResetPassword.vue